<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-8 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoActivo()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="tipoActivo.length > 0">
            <div class="col-md-5">
                <b-table
                    :items="tipoActivo"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editTipoActivo(item.id,item.tipo_activo)"
                >
                    <template #cell(tipo_activo)="data">
                        <div class="text-right">{{ data.item.tipo_activo }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="tipoActivo.length"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showTipoActivo" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoActivo" :infoEdit="dataTipoActivo" :infoCaract="listCaract" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo'
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica';
import Crear from './Crear.vue'
import Editar from './Editar.vue'
export default {
    name:'TipoActivo',
    components:{
        Crear,
        Editar
    },
    data: () => ({
        tipoActivo : [],
        showTipoActivo : false,
        showEditTipoActivo : false,
        dataTipoActivo : [],
        listCaract : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_activo', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros"
                }
            }else{
                return {
                    title: "Active type",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records"
                }
            }
        }
    },
    methods:{
        createTipoActivo(){
            this.showTipoActivo = true
        },
        editTipoActivo(id,tipo_activo){
            // console.log(id,tipo_activo);
            TipoActivoCaracteristica.getTipoActivoCaractByTipAct(tipo_activo)
            .then((res) => {
                // console.log(res.data.tipActCar);
                this.listCaract = res.data.tipActCar
            })
            .catch((error) => { console.log(error) })

            TipoActivo.getTipoActivoById(id)
            .then((res) => {
                // console.log(res.data.tipoActivo)
                this.dataTipoActivo = res.data.tipoActivo
                this.showEditTipoActivo = true
            })
            .catch((err) => { console.log(err)})
        },
        closeModal(valor){
            this.showTipoActivo = valor
            this.showEditTipoActivo = valor
        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo)
            this.tipoActivo = res.data.listTipoActivo
        })
        .catch((err) => { console.log(err)})
    }
}
</script>

<style>

</style>